module.exports = __webpack_public_path__ + "img/idea.379ebe24.svg";